<template>
	<v-img :src="path"></v-img>
</template>
<script>
import simpleNational from '@src/assets/images/icons/serves/icone-prestadores-de-servico.png'
export default {
	data() {
		return {
			path: simpleNational
		}
	},
}
</script>